const report = [
  {
    path: '/report',
    name: 'report',
    meta: { title: '企业信用报告在线预览', node: 'report', reviewType: 11 },
    component: () => import('../views/report/index.vue')
  },
  {
    path: '/report_result',
    name: 'report_result',
    meta: { title: '企业信用报告在线预览', node: 'report', reviewType: 11 },
    component: () => import('../views/report/result.vue')
  }
]

export default report;